//-------------------------------------------------------------------------------------------------- Imports
import { Row, Card, Typography, Col } from "antd";
import { StyleSheet } from "../../StyleSheet";
import SwipeableButton from "../../components/SwipeableButton";
import { useDispatch, useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { useCallback, useState } from "react";
import { provisioning } from "../../methods/Methods";
import Loading from "../../components/Loading";
import { AppDispatch } from "../../stores/store";
import { AlertSliceInterface, clearAlert, setAlert, showAlert } from "../../stores/slices/alertSlice";
const { Text } = Typography;

//-------------------------------------------------------------------------------------------------- View
const Provission = () => {
    const dispatch = useDispatch<AppDispatch>();
    const generalData = useSelector(getGeneralData);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const reset = async () => {
        let body = {
            sucursal: "",
            suscriptor: ""
        };
        if (generalData.selectedContract !== null) {
            body.sucursal = generalData.selectedContract.sucursal;
            body.suscriptor = generalData.selectedContract.suscriptor;
        }
        setIsLoading(true);
        let messageAlert = "";
        let typeAlert = "";
        await provisioning(body)
            .then((response) => {
                if (response.data) {
                    if (response.data.data[0].status === "true") {
                        typeAlert = "SUCCESS";
                        messageAlert = "Reaprovisionamiento realizado con éxito.";
                    } else {
                        typeAlert = "ERROR";
                        messageAlert = response.data.data[0].message;
                    }
                    let dispatchAlert: AlertSliceInterface = {
                        show: true,
                        type: typeAlert as "INFO" | "SUCCESS" | "ERROR",
                        title: "¡Estimado Usuario!",
                        message: messageAlert,
                        onFinalize: () => handleDispatchAlertModal()
                    }
                    openAlertModal(dispatchAlert);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                let dispatchAlert: AlertSliceInterface = {
                    show: true,
                    type: "ERROR",
                    title: "¡Estimado Usuario!",
                    message: "Lamentamos las molestias, intente más tarde.",
                    onFinalize: () => handleDispatchAlertModal()
                }
                openAlertModal(dispatchAlert);
                setIsLoading(false);
            });
    }

    const handleDispatchAlertModal = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
    }, [dispatch]);

    const openAlertModal = useCallback((option: AlertSliceInterface) => {
        dispatch(setAlert({
            show: option.show,
            type: option.type as "INFO" | "SUCCESS" | "ERROR",
            title: option.title,
            message: option.message,
            onFinalize: option.onFinalize
        }));
    }, [dispatch]);

    return (
        <>
            <Row style={styles.rowRoot}>
                <Col xs={16} xl={14} style={{ paddingLeft: 10 }}>
                    <Card bodyStyle={{ justifyContent: 'center' }} style={{ ...styles.cardRoot, marginTop: 10 }}>
                        <Row style={{ ...styles.rowRoot, marginBottom: 20 }}>
                            <Col xs={16} xl={16} style={styles.colRoot}>
                                <Text style={styles.textPrincipal}>
                                    {"Aquí puedes reaprovisionar tu equipo:"}
                                </Text>
                            </Col>
                            <Col xs={16} xl={16} style={styles.colRoot}>
                                <Text style={styles.textPrincipal}>
                                    {"Solo se podrá hacer una vez al día."}
                                </Text>
                            </Col>
                        </Row>
                        <Row style={styles.rowRoot}>
                            <Col xs={14} xl={14} style={styles.colRoot}>
                                <SwipeableButton
                                    onSuccess={reset}
                                    color='#0055c2'
                                    text='Deslice para confirmar'
                                />
                            </Col>
                        </Row>
                        {isLoading ?
                            <Loading />
                            : null
                        }
                    </Card>
                </Col>
            </Row>
        </>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    cardRoot: {
        backgroundColor: 'white',
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 20
    },
    colRoot: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 5
    },
    rowRoot: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 10
    },
    textPrincipal: {
        textAlign: 'center',
        fontFamily: "Montserrat",
        fontWeight: 600,
        fontSize: 14
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default Provission;
